import '@/assets/css/main.css'
import '@/i18n/i18n'
import './sentry'

import { initApiClient } from 'patient-api-lib'
import { PostHogProvider } from 'posthog-js/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import SuperTokens, { SuperTokensWrapper } from 'supertokens-auth-react'

import { frontendConfig } from './config/frontendConfig'
import { router } from './router'

SuperTokens.init(frontendConfig())
initApiClient(import.meta.env.VITE_API_DOMAIN, import.meta.env.VITE_BOOKING_WIDGET_API_TOKEN, import.meta.env.DEV)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        capture_exceptions: false,
        debug: import.meta.env.MODE === 'development',
        session_recording: {
          recordCrossOriginIframes: true,
        },
      }}
    >
      <React.Suspense fallback={<div />}>
        <SuperTokensWrapper>
          <RouterProvider router={router} />
        </SuperTokensWrapper>
      </React.Suspense>
    </PostHogProvider>
  </React.StrictMode>
)
